<template>
    <span class="markdown-content pre-wrap" v-html="renderedMarkdown">
    </span>
</template>

<script>
export default {
    name: 'ReMarkdown',
    props: {
        value: {
            type: String,
            required: true
        }
    },
    computed: {
        renderedMarkdown() {
            if (!this.value) {
                return '';
            }
            return this.value
                // Заголовки
                .replace(/^### (.+)$/gm, '<h3>$1</h3>')
                .replace(/^## (.+)$/gm, '<h2>$1</h2>')
                .replace(/^# (.+)$/gm, '<h1>$1</h1>')
                // Жирный и курсив
                .replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>')
                .replace(/\*(.+?)\*/g, '<strong>$1</strong>')
                .replace(/__(.+?)__/g, '<u>$1</u>')
                .replace(/_(.+?)_/g, '<em>$1</em>')
                .replace(/~(.+?)~/g, '<s>$1</s>')
                // Ссылки
                // .replace(/\[(.+?)\]\((.+?)\)/g, '<a href="$2" target="_blank" rel="noopener noreferrer">$1</a>')
                // Списки
                .replace(/^\s*-\s+(.+)$/gm, '<li>$1</li>')
                .replace(/^\s*\*\s+(.+)$/gm, '<li>$1</li>')
                .replace(/^\s*\+\s+(.+)$/gm, '<li>$1</li>')
                // Код
                .replace(/`(.+?)`/g, '<code>$1</code>')
                // Цитаты
                .replace(/^\s*> (.+)$/gm, '<blockquote>$1</blockquote>')
                // Горизонтальная линия
                // .replace(/^---$/gm, '<hr />')
                // // Перенос строки
                // .replace(/\n/g, '<br />')
                // // Обёртка списка
                // .replace(/(<li>.*<\/li>)/gs, '<ul>$1</ul>')
                // // Обёртка заголовков
                // .replace(/(<h1>|<h2>|<h3>)/g, '<div>$1')
                // .replace(/<\/h1>|<\/h2>|<\/h3>/g, '</div>')
                // // Обёрнка blockquote
                // .replace(/(<blockquote>.*<\/blockquote>)/g, '<div>$1</div>')
                // // Обёртка hr
                // .replace(/(<hr \/>)/g, '<div>$1</div>')
                // // Обёртка br
                // .replace(/(<br \/>)/g, '<br />')
                // // Обёртка div для ul
                // .replace(/(<ul>.*<\/ul>)/g, '<div>$1</div>')
                // // Очистка лишних div
                // .replace(/<div><div/g, '<div')
                // .replace(/<\/div><\/div>/g, '</div>')
        }
    }
}
</script>

<style scoped>
.markdown-content {
    line-height: 1.6;
    color: var(--text-color);
}

.markdown-content h1,
.markdown-content h2,
.markdown-content h3 {
    margin-top: 1rem;
    margin-bottom: 0.5rem;
    font-weight: 600;
}

.markdown-content code {
    background-color: var(--code-bg-color);
    padding: 0.2em 0.4em;
    border-radius: 0.25rem;
    font-family: var(--font-mono);
    font-size: 0.9em;
}

.markdown-content a {
    color: var(--primary-color);
    text-decoration: none;
}

.markdown-content a:hover {
    text-decoration: underline;
}

.markdown-content blockquote {
    border-left: 4px solid var(--primary-color);
    padding-left: 1rem;
    margin: 1rem 0;
    color: var(--text-muted);
}

.markdown-content ul {
    padding-left: 1.5rem;
    margin: 0.5rem 0;
}

.markdown-content li {
    margin: 0.25rem 0;
}
</style>
